import styled from "styled-components";
import { LIGHT_BLUE, NEAR_BLACK, NEAR_WHITE, WHITE } from "../../config";

export const Container = styled.div<{ showOptions: boolean }>`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  z-index: 4;
  svg {
    padding: 4px;
    font-size: 20px;
    transition: 0.2s ease;
    color: ${({ showOptions }) => (showOptions ? LIGHT_BLUE : NEAR_WHITE)};

    &:active {
      opacity: 0.7;
    }
    &:hover {
      color: ${LIGHT_BLUE};
    }
  }
`;

export const MenuList = styled.div`
  position: absolute;
  min-width: 120px;
  height: auto;
  display: block;
  background: ${NEAR_BLACK};
  border-radius: 8px;
  z-index: 5;
  animation: openMenu 0.2s ease-out;
  padding: 16px;
  color: ${WHITE};
  right: 15px;
  top: 3px;
`;

export const Item = styled.div`
  padding: 4px;
  cursor: pointer;

  &:hover {
    color: ${LIGHT_BLUE};
  }
`;
